import { type TimelineGranularity } from "../client/svcIntegrationsClient";

export const PERIODS: { label: string; days: number; granularity: TimelineGranularity }[] = [
  { label: "1 Week", days: 7, granularity: "TIMELINE_GRANULARITY_DAY" },
  { label: "1 Month", days: 30, granularity: "TIMELINE_GRANULARITY_WEEK" },
  { label: "1 Year", days: 365, granularity: "TIMELINE_GRANULARITY_MONTH" },
];
